import React from 'react'

export default function LinearColorText({ children }: { children: React.ReactNode }) {
  return (
    <span className="animate-text bg-clip-text text-transparent">
        {children}
    </span>
  )
}
